import type { StyleResolverContext, CssFragment } from './index';
import type { FlexProps } from './flex';

// ============================================================================
// Types
// ============================================================================

export interface OverflowProps {
  overflowHidden?: boolean;
  overflowXHidden?: boolean;
  overflowYHidden?: boolean;
  scrollX?: boolean;
  scrollY?: boolean;
}

export type OverflowFlexProps = OverflowProps & FlexProps;

// ============================================================================
// Resolution helpers
// ============================================================================

/** Returns CSS fragments for overflow. */
const resolveOverflowCss = (props: OverflowProps): CssFragment[] => [
  props.overflowHidden ? 'overflow: hidden;' : null,
  props.overflowXHidden ? 'overflow-x: hidden;' : null,
  props.overflowYHidden ? 'overflow-y: hidden;' : null,
  props.scrollX ? 'overflow-x: scroll;' : null,
  props.scrollY ? 'overflow-y: scroll;' : null,
];

// ============================================================================
// Picker + style resolver
// ============================================================================

const pickOverflowProps = <T extends Partial<OverflowProps>>(props: T): OverflowProps => {
  const { overflowHidden, overflowXHidden, overflowYHidden, scrollX, scrollY } = props;
  return { overflowHidden, overflowXHidden, overflowYHidden, scrollX, scrollY };
};

export const resolveOverflowStyleCss = (props: Record<string, unknown>, _theme: StyleResolverContext): CssFragment[] =>
  resolveOverflowCss(pickOverflowProps(props as Partial<OverflowProps>));
